export default __webpack_public_path__ + "static/media/Pinterest.a70442c5.png";